import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { getApisData } from '../utils/HelperFunctions';
import ChartDirection from './ChartDirection';
import { useEffect, useMemo } from 'react';
import ChartJsLineChart from '../../../components/charts/ChartJsLineChart';

interface MonthlySalesProps {
  monthlySalesData: any;
}

const MonthlySales = ({ monthlySalesData }: MonthlySalesProps) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    return (
      monthlySalesData?.data?.data?.map((item: any) => ({
        x: item.month_name,
        value: item.vehicles_sold
      })) || []
    );
  }, [monthlySalesData]);

  return (
    <div>
      <ListHeader customClass="row">
        <h2 style={{visibility: 'hidden'}}>{t('dashboardCharts.vehicles')}</h2>
      </ListHeader>

      <div className="dashboard-data vehicles">
        <div className="charts">
          <ChartDirection>
            <ChartJsLineChart
              data={chartData}
              title={t('dashboardCharts.monthly_sales')}
              yAxisLabel={t('dashboardCharts.sales')}
              tooltipLabel={t('dashboardCharts.sales')}
              stroke="#000"
              strokeWidth={2}
              dotProps={{ fill: '#000', strokeWidth: 2, r: 4 }}
            />
          </ChartDirection>
        </div>
      </div>
    </div>
  );
};

export default MonthlySales;
